import type { PropsWithChildren } from 'react';

import { twMerge } from 'tailwind-merge';

export function PageHeaderCtrlContainer({ children, className }: PropsWithChildren<{ className?: string }>) {
  return (
    <div className={twMerge('mt-1 -ml-2 flex flex-0 items-center justify-center gap-1 md:justify-start', className)}>
      {children}
    </div>
  );
}
